export default __webpack_public_path__ + "static/virtualbox-29ab11a92349e03163a1d1a4746a0590.png";